module.exports = __webpack_public_path__ + "static/media/josie-ide.9500232e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/App/About/josie-ide.jpg
// module id = 467
// module chunks = 0